@if(appReady()) {
  <rc-app-submit-bar></rc-app-submit-bar>
  <router-outlet></router-outlet>
} @else {
  <div class="sk-layout">

    <!-- App bar — real gradient, skeleton right side -->
    <header class="sk-appbar">
      <kendo-skeleton shape="circle" animation="pulse" class="sk-avatar sk-appbar__menup"></kendo-skeleton>
      <h1 class="sk-appbar__title">
        CROWNBASE<span class="sk-appbar__accent"> | NXT</span>
      </h1>
      <kendo-skeleton shape="circle" animation="pulse" class="sk-avatar"></kendo-skeleton>
    </header>

    <div class="sk-main">

<!--      &lt;!&ndash; Sidebar nav skeleton &ndash;&gt;-->
<!--      <nav class="sk-nav">-->
<!--        @for (i of [1,2,3,4,5,6,7,8]; track i) {-->
<!--          <kendo-skeleton shape="circle" animation="pulse" class="sk-nav__icon"></kendo-skeleton>-->
<!--        }-->
<!--      </nav>-->

      <!-- Content skeleton -->
      <div class="sk-content mt-24">

        @if (userLoadError()) {
          <rc-app-load-error (retry)="retryLoadUser()" />
        } @else {
        <!-- RC logo + shimmer lines centered -->
        <div class="sk-hero">
          <svg class="sk-logo" viewBox="0 0 54 30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M12.7 29.4L7.2 19.2L20 21.9L26.7 8.7L32.9 22.1L46.1 19.3L40.8 29.4H45.2L53.3 13.9L35.3 17.5H35.2L26.6 0L17.9 17.5L0 13.9L8.1 29.4H12.7Z"/>
          </svg>
          <kendo-skeleton shape="text" animation="pulse" class="sk-line sk-line--xl"></kendo-skeleton>
          <kendo-skeleton shape="text" animation="pulse" class="sk-line sk-line--lg"></kendo-skeleton>
          <kendo-skeleton shape="text" animation="pulse" class="sk-line sk-line--md"></kendo-skeleton>
        </div>

        <!-- Skeleton stat cards -->
        <div class="sk-cards">
          @for (i of [1,2,3,4]; track i) {
            <div class="sk-card">
              <kendo-skeleton shape="text" animation="pulse" class="sk-card__label"></kendo-skeleton>
              <kendo-skeleton shape="text" animation="pulse" class="sk-card__value"></kendo-skeleton>
            </div>
          }
        </div>

        <!-- Skeleton table rows -->
        <div class="sk-rows">
          @for (i of [1,2,3,4,5,6]; track i) {
            <kendo-skeleton shape="text" animation="pulse" class="sk-row" [style.width]="(100 - i * 4) + '%'"></kendo-skeleton>
          }
        </div>
        }

      </div>
    </div>
  </div>
}
